/* Signora PDP – compact metal picker for phones (<=749px).
   Renders one row of metal swatches + one karat row, and drives the existing
   desktop controls (.sjwpp-tab / .sjwpp-k) so variant, price and summary logic
   stay in one place. Desktop keeps the original tabs + rows. */
(function () {
  'use strict';

  function esc(v) { return String(v).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function txt(el) { return (el && el.textContent || '').replace(/\s+/g, ' ').trim(); }
  function dotColor(el) { var d = el && el.querySelector('.sjwpp-dot'); return d ? d.style.background || getComputedStyle(d).backgroundColor : '#ddd'; }
  function off(btn) { return !btn || btn.disabled || btn.classList.contains('na') || btn.getAttribute('aria-disabled') === 'true'; }
  function karatOf(btn) { var m = txt(btn).match(/\d+\s*K/i); return m ? m[0].replace(/\s+/g, '').toUpperCase() : txt(btn); }
  function colourOf(row) {
    var m = (row.className.match(/sjwpp-c-([a-z0-9-]+)/) || [])[1];
    return m || txt(row.querySelector('.sjwpp-rl')).toLowerCase();
  }

  function init(card) {
    var tabsEl = card.querySelector('[data-sjwpp-tabs]');
    var panel = card.querySelector('[data-sjwpp-panel]');
    if (!tabsEl || !panel || card.querySelector('.sjw-mx')) return;

    var goldTab = tabsEl.querySelector('.sjwpp-tab[data-t="gold"]');
    var gold = {};          /* colour -> {label, color} remembered from the gold rows */
    var goldOrder = [];
    var lastKarat = null;

    var ui = document.createElement('div');
    ui.className = 'sjw-mx';
    ui.innerHTML = '<div class="sjw-mx-sw" role="group" aria-label="Metal"></div><div class="sjw-mx-k" role="group" aria-label="Karat"></div>';
    var swRow = ui.firstChild, kRow = ui.lastChild;
    tabsEl.parentNode.insertBefore(ui, tabsEl);

    function readGold() {
      [].forEach.call(panel.querySelectorAll('.sjwpp-row'), function (row) {
        var c = colourOf(row);
        if (!gold[c]) { goldOrder.push(c); }
        gold[c] = { label: txt(row.querySelector('.sjwpp-rl')) || c, color: dotColor(row) };
      });
    }

    function state() {
      var activeTab = tabsEl.querySelector('.sjwpp-tab.on');
      var t = activeTab ? activeTab.getAttribute('data-t') : 'gold';
      var onK = panel.querySelector('.sjwpp-k.on');
      var row = onK ? onK.closest('.sjwpp-row') : null;
      return { tab: t, colour: (t === 'gold' && row) ? colourOf(row) : null, karat: onK ? karatOf(onK) : null };
    }

    function waitRows(cb, n) {
      n = n || 0;
      if (panel.querySelector('.sjwpp-row .sjwpp-k') || n > 40) { cb(); return; }
      requestAnimationFrame(function () { waitRows(cb, n + 1); });
    }

    function pickGold(colour, karat) {
      var go = function () {
        var row = null;
        [].forEach.call(panel.querySelectorAll('.sjwpp-row'), function (r) { if (colourOf(r) === colour) row = r; });
        if (!row) return;
        var btns = [].slice.call(row.querySelectorAll('.sjwpp-k'));
        var want = karat || lastKarat;
        var b = btns.filter(function (x) { return karatOf(x) === want && !off(x); })[0] || btns.filter(function (x) { return !off(x); })[0];
        if (b && !b.classList.contains('on')) b.click();
        render();
      };
      if (goldTab && !goldTab.classList.contains('on')) { goldTab.click(); waitRows(go); } else { go(); }
    }

    function button(cls, html, label, pressed, disabled, onClick) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = cls + (pressed ? ' on' : '');
      b.innerHTML = html;
      b.setAttribute('aria-pressed', pressed ? 'true' : 'false');
      if (label) b.setAttribute('aria-label', label);
      if (disabled) { b.disabled = true; }
      b.addEventListener('click', onClick);
      return b;
    }

    function render() {
      readGold();
      var s = state();
      if (s.karat && s.tab === 'gold') lastKarat = s.karat;
      swRow.innerHTML = '';
      goldOrder.forEach(function (c) {
        var g = gold[c];
        swRow.appendChild(button('sjw-mx-s', '<span class="sjw-mx-dot" style="background:' + esc(g.color) + '"></span><span class="sjw-mx-l">' + esc(g.label) + '</span>',
          g.label + ' gold', s.tab === 'gold' && s.colour === c, false, function () { pickGold(c, lastKarat); }));
      });
      [].forEach.call(tabsEl.querySelectorAll('.sjwpp-tab'), function (tab) {
        var t = tab.getAttribute('data-t');
        if (t === 'gold') return;
        var label = txt(tab.querySelector('.sjwpp-tn')) || t;
        swRow.appendChild(button('sjw-mx-s', '<span class="sjw-mx-dot" style="background:' + esc(dotColor(tab)) + '"></span><span class="sjw-mx-l">' + esc(label) + '</span>',
          label, s.tab === t, off(tab), function () { if (!tab.classList.contains('on')) tab.click(); setTimeout(render, 30); }));
      });
      swRow.style.gridTemplateColumns = 'repeat(' + Math.max(1, swRow.children.length) + ',minmax(0,1fr))';

      kRow.innerHTML = '';
      var row = null;
      if (s.tab === 'gold') {
        [].forEach.call(panel.querySelectorAll('.sjwpp-row'), function (r) { if (colourOf(r) === s.colour) row = r; });
      }
      if (row) {
        [].forEach.call(row.querySelectorAll('.sjwpp-k'), function (k) {
          var kk = karatOf(k);
          kRow.appendChild(button('sjw-mx-kb', esc(kk), kk + ' ' + (gold[s.colour] ? gold[s.colour].label : '') + ' gold', k.classList.contains('on'), off(k), function () {
            if (!k.classList.contains('on')) k.click(); lastKarat = kk; setTimeout(render, 30);
          }));
        });
        kRow.style.gridTemplateColumns = 'repeat(' + Math.max(1, kRow.children.length) + ',minmax(0,1fr))';
        kRow.hidden = false;
      } else {
        kRow.hidden = true;
      }
    }

    readGold();
    if (!goldOrder.length) { ui.remove(); return; }   /* nothing to compact: leave the original UI alone */
    card.classList.add('sjw-mx-ready');
    render();

    var mo = new MutationObserver(function () { clearTimeout(mo._t); mo._t = setTimeout(render, 40); });
    mo.observe(tabsEl, { attributes: true, subtree: true, attributeFilter: ['class', 'aria-pressed', 'disabled'] });
    mo.observe(panel, { childList: true, attributes: true, subtree: true, attributeFilter: ['class', 'aria-pressed', 'disabled'] });
  }

  function sweep() {
    [].forEach.call(document.querySelectorAll('[data-sjwpp-tabs]'), function (t) {
      var card = t.parentNode;
      if (card && card.querySelector('[data-sjwpp-panel] .sjwpp-row')) init(card);
    });
  }

  var n = 0, iv = setInterval(function () { sweep(); if (++n > 40 || document.querySelector('.sjw-mx')) clearInterval(iv); }, 150);
  if (document.readyState !== 'loading') sweep(); else document.addEventListener('DOMContentLoaded', sweep);
})();
